<template>
  <div class="panel wraper panel-gray">
    <div class="panel-header">
      <div class="panel-title">
        <unit-path v-once :id="iniPerson.parent_id" :lbl="lbl"></unit-path>
      </div>
    </div>
    <div class="panel-body" id="formbody">
      <q-field
        :error="$v.tempPerson.name.$error"
        :error-label="$v.tempPerson.name | errorLabel"
      >
        <q-input v-model.trim="tempPerson.name" :autofocus="true" float-label="ФИО" />
      </q-field>
      <q-field>
        <q-input v-model.trim="tempPerson.appointment" float-label="Должность" />
      </q-field>
      <q-field>
        <q-input type="textarea" :rows="1"
                 v-model.trim="telString" float-label="Контакты" />
      </q-field>
      <q-field>
        <q-input type="textarea" :rows="1"
                 v-model.trim="tempPerson.comment" float-label="Заметки" />
      </q-field>
    </div>
    <save-btn :notChanged="notChanged" :goView="goView" :doSave="doSave" />
  </div>
</template>


<script type="text/babel">
import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
import UnitPath from './unit-path.vue';
import SaveBtn from './save-btn.vue';

export default {
  name: 'personedit',
  components: {
    UnitPath,
    SaveBtn,
  },
  data() {
    const iniPerson = {
      name: '',
      appointment: '',
      comment: '',
      telephones: [],
    };
    if (this.$route.name === 'unitNew') { // new person
      iniPerson.parent_id = this.$route.params.parent_id;
    } else {
      Object.assign(iniPerson, this.$store.state.units[this.$route.params.id]);
    }
    return {
      iniPerson,
      tempPerson: Object.assign({}, iniPerson),
    };
  },
  validations: {
    tempPerson: {
      name: {
        required: withParams({ message: 'Введите ФИО' }, required),
      },
    },
  },
  mounted() {
    this.$watch('lbl', (a) => {
      document.title = a;
    }, {
      immediate: true,
    });
  },
  computed: {
    lbl() {
      if (this.addNew) {
        return '*Новый сотрудник*';
      }
      return this.iniPerson.name;
    },
    notChanged() {
      return _.isEqual(this.iniPerson, this.tempPerson);
    },
    telString: {
      get() {
        return this.tempPerson.telephones.join('\n');
      },
      set(newValue) {
        this.tempPerson.telephones = newValue.split('\n').map(t => t.trim());
      },
    },
    pid() {
      return this.iniPerson.parent_id;
    },
    id() {
      return this.$route.params.id;
    },
    addNew() {
      return (this.$route.name === 'unitNew');
    },
  },
  methods: {
    doSave() {
      this.$v.tempPerson.$touch();
      if (this.$v.tempPerson.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      if (this.addNew) {
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        this.tempPerson._id = `pers:${timestamp}${'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase()}`;
      }
      // this turn off warning
      Object.assign(this.iniPerson, this.tempPerson);
      this.$store.dispatch('saveUnit', this.tempPerson)
        .then(() => {
          this.$router.jumpBack();
        })
        .catch(() => {
          this.$store.commit('pushError', {
            error: 'Ошибка!',
            message: 'Возможно изменения не сохранены',
          });
          this.goView();
        });
    },
    goView() {
      // this turn off warning -- removed
      // Object.assign(this.iniPerson, this.tempPerson);
      this.$router.jumpBack();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/person-edit.vue